export default __webpack_public_path__ + "static/media/LOGO.55fed87c.png";